import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { IUser } from 'app/interfaces/user.interface';
import { ApiRoutes } from 'app/routes/app.routes';
import { HttpService } from '../http/http.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private routes = ApiRoutes.api;

  constructor(private router: Router, private httpService: HttpService) { }

  createAccount(payload: IUser) {
    return this.httpService.makeRequest({
      path: this.routes.user.add,
      method: 'post',
      options: { body: payload },
      loader: { type: 'button' },
      isAuthRoutes: false
    });
  }


  login(payload: IUser) {
    return this.httpService.makeRequest({
      path: this.routes.user.login,
      method: 'post',
      options: { body: payload },
      loader: { type: 'button' },
      isAuthRoutes: false
    });
  }

  logout() {
    localStorage.clear();
    this.router.navigate(['/auth/login']);
  }

  forgotPassword(email: string) {
    return this.httpService.makeRequest({
      path: this.routes.user.forgotPassword,
      method: 'post',
      options: { body: { email } },
      loader: { type: 'button' },
      isAuthRoutes: false
    });
  }

  resetPassword(id: number, payload: { newPassword: string, confirmPassword: string }) {
    return this.httpService.makeRequest({
      path: this.routes.user.resetPassword,
      method: 'put',
      options: { id, body: payload },
      loader: { type: 'button' },
      isAuthRoutes: false
    });
  }

  regeneratePassword(id: number) {
    return this.httpService.makeRequest({
      path: this.routes.user.regeneratePassword,
      method: 'put',
      options: { id },
      loader: { type: 'button' },
      isAuthRoutes: true
    });
  }
}
